angular.module('jv.Dashboard.AllOpenJobs.Controller', ['jv.Common.Directives.HideOnBlur'])
.controller('jv.Dashboard.AllOpenJobs.Controller',
    ['$scope','jvDashboardAjaxService', 'jvContextualLoadingService', '$window', 'Reqs','$rootScope', 'TemplateLoader','$jobviteUrls',
    function($scope, jvDashboardAjaxService, jvContextualLoadingService, $window, Reqs, $rootScope, TemplateLoader, $jobviteUrls){
        $scope.refreshTimestamp = true;
        $scope.jvUrls = $jobviteUrls;
        $rootScope.$on('REFRESH_WIDGET', function(event,widgetData) {
            if(widgetData && ($scope.widgetObject.widgetId === widgetData.widgetId)){
                $scope.refreshTimestamp = false;
                $scope.fetchallJobs(0);
            }
        });
        $scope.pageSize = 10;
        $scope.totalCount = 0;
        $scope.currentPage = 0;
        var sortBy, sortOrder, postingTypes, subsidiaries, regions, locations, departments, categories, reqTypes, sourceIds;
        $scope.sendJobvite = function(EId){
            $window.location.href = $scope.jvUrls.source+"/source/share/shareJobvite.html?jobIds="+EId;
        };
        
        $scope.share = function(job, clickOutside){
        	if(clickOutside) {
        		job.shareDropDown = false;
        	} else {
        		angular.forEach($scope.allJobs, function(value, index){
            		if(value.EId !== job.EId) {
            			value.shareDropDown = false;
            		}
            	});
            	job.shareDropDown = !job.shareDropDown;
        	}
        };
        
        $scope.apply = function(EId){
            $window.location.href = $scope.jvUrls.forum+"/Jobs/Apply.aspx?v=1&j="+EId+"&rt=/Hiring/ViewJob.aspx";
        };

        $scope.fetchallJobs = function(pageNumber){
            //Settings logic needs to be reused across myopen jobs and all open jobs
            var settingsInfo = $scope.widgetObject.userWidgetSettings.widgetSetting;
            angular.forEach(settingsInfo, function(settingInfo, index){
                var values;
                if (settingInfo.userValues) {
                    values = settingInfo.userValues;
                } else if(settingInfo.settings.defaultValues){
                    values = settingInfo.settings.defaultValues;
                }

                if(values){
                    if(values[0] && angular.isObject(values[0].label) && values[0].EId){
                        values[0].value = angular.copy(values[0].EId);
                        values[0].label = angular.copy(values[0].label.name);
                        delete values[0].EId;
                    } else if(values[0].label && values[0].label.name){
                        //filters with label and no EId property Eg: SourceType
                        //posting type has index attribute
                        if(values[0].label.index != null){
                            values[0].index = angular.copy(values[0].label.index);
                        }
                        values[0].value = angular.copy(values[0].label.name);
                        values[0].label = angular.copy(values[0].label.name);
                    }
                    //Making sure UI doesnt make a call with all filter
                    if($.isEmptyObject(values[0].label)){
                        values[0].label = '';
                        values[0].value = null;
                    }
                    switch(settingInfo.settings.name) {
                        case "SortBy":
                            sortBy = values[0].value;
                            break;
                        case "SortOrder":
                            sortOrder = values[0].value;
                            break;
                        case "PostingType":
                            if(values[0]){
                                if(values[0].index != null){
                                    values[0].value = angular.copy(values[0].index);
                                    delete values[0].index;
                                }
                            }
                            postingTypes = values[0].value;
                            break;
                        case "Company":
                            subsidiaries = values[0].value;
                            break;
                        case "Region":
                            regions = values[0].value;
                            break;
                        case "Location":
                            locations = values[0].value;
                            break;
                        case "Department":
                            departments = values[0].value;
                            break;
                        case "Category":
                            categories = values[0].value;
                            break;
                        case "RequisitionType":
                            reqTypes = values[0].value;
                            break;
                        default:
                            break;
                    }
                }
            });

            jvContextualLoadingService.show($scope.widgetObject.widgetId);
            $scope.currentPage = pageNumber;
            var postData = {
                page: pageNumber,
                refreshGrid:'refreshGrid',
                searchAllReq: true,
                maxResults: $scope.pageSize,
                fetchFeaturedJobs: true,
                jobStateValue: 1,
                sortBy: sortBy,
                order: sortOrder,
                subsidiaryId: subsidiaries,
                regionIds: regions,
                locationIds : locations,
                departmentIds : departments,
                categoryIds : categories,
                typeIds : reqTypes,
                postingType:postingTypes
            };
            jvDashboardAjaxService.getAllJobs(postData,function(response){
                jvContextualLoadingService.hide($scope.widgetObject.widgetId);
                $scope.refreshTimestamp = true;
                $scope.totalCount = response.jobCount || 0;
                if(response.jobs){
                    $scope.allJobs = response.jobs;
                }else {
                    $rootScope.showMsg('ERROR_PROCESSING_REQUEST');
                }
            });
        };
        $scope.fetchallJobs(0);
}]);
